import React from 'react';
import {Link, useTheme} from '@fluentui/react';
import {openEntity} from '../GlobalSearch/useGlobalSearchHotkey';

interface IProductOpenLinkProps {
    /** The product the text opens; plain text when absent (adhoc lines, examples). */
    productId?: string;
    /** Tab to land on. Default is the first (Details) tab. */
    tab?: 'details' | 'media' | 'vendor' | 'purchaseHistory';
}

/**
 * Grid text that opens the product's details modal on click (the MFP cell). Reads as plain text
 * at rest and turns brand green on hover, like the manufacturer filter link.
 */
const ProductOpenLink: React.FC<IProductOpenLinkProps> = ({productId, tab, children}) => {
    const theme = useTheme();
    if (!productId) return <span>{children}</span>;
    return (
        <Link
            title='Open the product details'
            onClick={(e) => {
                e.stopPropagation();
                openEntity({kind: 'product', productId, initialTab: tab ?? 'details'});
            }}
            styles={{
                root: {
                    color: theme.palette.neutralPrimary,
                    selectors: {
                        ':hover': {color: theme.palette.themePrimary, textDecoration: 'underline'},
                        ':active': {color: theme.palette.themeDark},
                    },
                },
            }}
        >
            {children}
        </Link>
    );
};

export default ProductOpenLink;
